"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitWeightMap = exports.convertibleVolumes = exports.unitVolumeMap = void 0;
exports.unitVolumeMap = {
    cup: 1,
    liter: 0.24,
    milliliter: 240,
    ["fluid ounce"]: 8.115,
    teaspoon: 48,
};
exports.convertibleVolumes = {
    cup: true,
    liter: true,
    milliliter: true,
    ["fluid ounce"]: true,
};
exports.unitWeightMap = {
    gram: 1,
    ounce: 0.035274,
    pound: 0.00220462,
    milligram: 1000,
    kilogram: 0.001,
};
//# sourceMappingURL=unitVolumeMap.js.map